import React, { useEffect, useRef, useState } from 'react';
import { useStore } from '../../../utils/store';
import DownloadIcon from '@mui/icons-material/Download';
import Constants from '../../../utils/constants';
import HttpService from '../../../services/HttpService';
import Grid from '@mui/material/Grid2';
import { useSearch } from '../../../components/searchContext';
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Divider,
  IconButton,
  Paper,
  TextField,
  Typography,
} from '@mui/material';

import AddButtonComponent from '../../../components/form/AddButtonComponent';
import CustomPaginationActionsTable from '../../../components/TablePagination';
import { MailOutlineOutlined } from '@mui/icons-material';
import FormFieldData from '../../../Models/FormFieldData';
import SimpleDialogComponent from '../../../components/SimpleDialogComponent';
import CommonForm from '../../../components/form/CommonForm';
import { currentDatePlusDate, downloadFile } from '../../../utils/storageUtil';
import AlertMessageComponent from '../../../components/AlertMessageComponent';
import ButtonComponent from '../../../components/form/ButtonComponent';
import { useAlert } from '../../../components/alertContext';

interface ProjectDocumentsProps {
  projectInternalId: number;
  customerEmail: any;
  customerName: any;
  projectName: any;
  documentTypeList: any[];
}
const ProjectDocuments: React.FC<ProjectDocumentsProps> = ({
  projectInternalId,
  customerEmail,
  customerName,
  projectName,
  documentTypeList,
}) => {
  const { searchQuery } = useSearch();
  const isInitialLoad = useRef(true);
  const { getAdmin } = useStore();

  const [currentRecord, setCurrentRecord] = useState<any>(null);
  const columns: any[] = [
    {
      field: 'id',
      headerName: 'Type',
      renderCell: (value: any, row: any) => (
        <Box sx={{ display: 'flex', alignItems: 'anchor-center' }}>
          <Checkbox
            edge="start"
            checked={checkedIds.includes(value)}
            tabIndex={-1}
            disableRipple
          />

          <Box sx={{ display: 'flex', alignItems: 'anchor-center' }}>
            {row.documentTypeName}
          </Box>
        </Box>
      ),
    },
    {
      field: 'name',
      headerName: 'Name',
    },
    {
      field: 'expiryDate',
      headerName: 'Expiry Date',
    },
    {
      field: 'notes',
      headerName: 'Notes',
    },
  ];

  const [paginate, setPaginate] = useState<any>({
    limit: Constants.DEFAULT_PAGE_SIZE,
    offset: 0,
  });
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const { alert, setAlert, handleCloseAlert } = useAlert();
  const [currentId, setCurrentId] = useState<number | string>(0);

  const [addNewDialogOpen, setAddNewDialogOpen] = useState<boolean>(false);
  const [sendMailDialog, setSendMailDialog] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [inProgress, setInProgress] = useState<boolean>(false);
  const [fileDownloading, setFileDownloading] = useState<any>(null);
  const [checkedIds, setCheckedIds] = useState<any[]>([]);
  const [rows, setRows] = useState<any>([]);
  type formData = {
    [k: string]: { required: boolean; value: any };
  };
  const [mailForm, setMailForm] = useState<any>({
    to: customerEmail,
    subject: projectName,
    body: '',
  });

  const handleSelectedIds = async (id: any) => {
    console.log(id);
    setCheckedIds((prevItems: any) => {
      const newItems = [...prevItems];
      if (!newItems.includes(id)) {
        newItems.push(id);
      } else {
        newItems.splice(newItems.indexOf(id), 1);
      }
      return newItems;
    });
  };
  const handleChangeMailBody = (e: any) => {
    const { name, value } = e.target;

    setMailForm((prev: any) => {
      return { ...prev, [name]: value };
    });
  };

  const handleDownloadAll = async (IDs: any) => {
    const endpoint = `${Constants.apiURL + Constants.documentPDFsURL}/project/${projectInternalId}`;
    let response: any;
    try {
      setIsDownloading(true);
      response = await HttpService.get(
        endpoint,
        {
          headers: {
            Authorization: `Bearer ${getAdmin()}`,
            Accept: 'application/pdf',
          },

          responseType: 'blob',
        },
        { documentIds: IDs }
      );

      if (response) {
        downloadFile(response, `project_${projectInternalId}.pdf`);
        setIsDownloading(false);
      }
    } catch (error: any) {
      setIsDownloading(false);
      console.error(`GET ERROR:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };

  const [form, setForm] = useState<formData>({
    id: { required: false, value: null },
    name: { required: true, value: '' },
    documentTypeId: { required: true, value: null },
    expiryDate: { required: true, value: currentDatePlusDate(2, 0, 0) },
    notes: { required: true, value: '' },
    documentFile: { required: true, value: [] },
  });
  useEffect(() => {
    if (paginate || isInitialLoad.current) {
      fetchData();
    }
    isInitialLoad.current = false;
  }, [paginate]);

  const clearForm = () => {
    setAddNewDialogOpen(false);
    setSendMailDialog(false);
    fetchData();
  };

  const fetchSingleDocument = async (id: any) => {
    try {
      setFileDownloading(id);
      const URL = `${Constants.apiURL}${Constants.documentURL}`;
      const response = await HttpService.get(
        URL,
        { headers: { Authorization: 'Bearer ' + getAdmin() } },
        { id }
      );
      console.log(response);
      if (response.data) {
        setFileDownloading(false);
        window.open(response.data, '_blank');
      }

      console.log('GET Response:', response);
    } catch (error: any) {
      console.error(`GET ERROR:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
      setFileDownloading(false);
    }
  };

  const handleFileChange = (file: any) => {
    setForm((prev: any) => {
      return {
        ...prev,
        documentFile: { required: prev['documentFile'].required, value: file },
      };
    });
  };

  const handleRemove = (file: any) => {
    setForm((prev: any) => {
      return {
        ...prev,
        documentFile: { required: prev['documentFile'].required, value: [] },
      };
    });
  };
  const AddDialogContent = () => {
    return (
      <Box style={{ width: '800px' }}>
        <CommonForm
          singlePage={true}
          fields={formFields}
          onCancel={() => {}}
          formReset={clearForm}
          formTitle={currentRecord ? 'Add New Document' : 'Update Document'}
          isLoading={isLoading}
          isUpdate={currentId !== 'Add' ? true : false}
          onSave={handleSave}
          actionButtonPosition="bottom"
        />
      </Box>
    );
  };

  const handleSave = async () => {
    try {
      const token = getAdmin();

      if (currentRecord) {
        const fileData = {
          id: currentRecord.id,
          fileName: currentRecord.document.fileName,
          filePath: currentRecord.document.filePath,
        };
        const response: any = await saveRecord(fileData, token);
        if (response.success) {
          clearForm();
        }
        setIsLoading(false);
        return true;
      } else {
        if (form.documentFile.value.length === 0) {
          setAlert({ type: 'error', message: 'File is required', open: true });
          return false;
        }
        const file: any = form.documentFile.value[0];
        if (file) {
          setIsLoading(true);

          const signedData: any = await HttpService.handlePresignedDocument(
            file,
            'project',
            projectInternalId,
            token
          );
          console.log(`signedData`);
          console.log(signedData);
          console.log(`signedData`);
          if (signedData) {
            const response: any = await saveRecord(signedData, token);
            if (response.success) {
              setIsLoading(false);
              clearForm();
            }
            console.log('GET Response:', response);
          }
        }
      }
    } catch (error: any) {
      console.error(`GET ERROR:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
      setIsLoading(false);
    }
  };

  const saveRecord = async (signedData: any, token: any) => {
    const postData: any = {
      documentTypeId: form.documentTypeId.value,
      name: form.name.value,
      notes: form.notes.value,
      expiryDate: form.expiryDate.value,
      filePath: signedData.filePath,
      fileName: signedData.fileName,
    };
    if (currentRecord) {
      postData['id'] = signedData.id;
    }
    const response: any = await HttpService.post(
      Constants.apiURL +
        Constants.documentURL +
        '/project?id=' +
        projectInternalId,
      postData,
      {
        headers: {
          Authorization: 'Bearer ' + token,
        },
      }
    );
    return response;
  };
  const handleStatus = (row: any) => {
    handleSelectedIds(row.id);
  };

  const handlePagination = (paginationData: any) => {
    console.log(paginationData);
    setPaginate(paginationData);
  };

  const fetchData = async () => {
    try {
      const response = await HttpService.get(
        `${Constants.apiURL}${Constants.documentURL}/project`,
        { headers: { Authorization: `Bearer ${getAdmin()}` } },
        {
          id: projectInternalId,
          search: searchQuery,
          limit: paginate.limit,
          offset: paginate.offset,
        }
      );
      if (response.success) {
        setRows(response.data.paginateRecords);
        setTotalRecords(response.data.total);
      }
      console.log('GET Response:', response);
    } catch (error: any) {
      console.error(`GET ERROR:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };
  const handleInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setForm((prevData) => ({
      ...prevData,
      [name]: { ...prevData[name], value: value },
    }));
  };
  const handleExpiryDate = (value: any) => {
    const expiryDateValue =
      value.year() + '-' + (value.month() + 1) + '-' + value.date();
    setForm((prev: any) => {
      return {
        ...prev,
        expiryDate: {
          required: prev['expiryDate'].required,
          value: expiryDateValue,
        },
      };
    });
  };
  const mailcontentHTML = () => {
    const selectedDocumentTypes = rows
      .filter((record: any) => checkedIds.includes(record.id)) // Filter records with matching IDs
      .map((record: any) => record.documentTypeName);
    return `
    <div style="font-family: Arial, sans-serif; line-height: 1.6; color: #333; padding: 20px; background-color: #f9f9f9;">
      <div style="max-width: 900px;">
        <p style="font-size: 16px; margin: 0 0 10px;">Dear ${customerName},</p>
        <p style="font-size: 16px; margin: 0 0 10px;"></p>
  
        <p style="font-size: 16px; margin: 0 0 10px;">
          Please find attached documents for the ${projectName} ${selectedDocumentTypes.join(',')} Requested Documents
        </p>
        <p style="font-size: 16px; font-weight: bold; margin: 0;">Regards,</p>
        <p style="font-size: 16px; margin: 0;">Loumac</p>
      </div>
    </div>
  
  `;
  };
  const handleSendEmail = async () => {
    try {
      if (!mailForm.to.trim()) {
        setAlert({
          type: 'error',
          message: 'Email address is required',
          open: true,
        });
        return false;
      }
      if (checkedIds.length <= 0) {
        setAlert({
          type: 'error',
          message: 'Please select as least one document',
          open: true,
        });
        return false;
      }
      setInProgress(true);
      const endpoint = `${Constants.apiURL}/email/sendProjectDocument`;
      const response = await HttpService.post(
        endpoint,
        {
          toemails: mailForm.to.split(','),
          htmlbody: mailcontentHTML(),
          subject: mailForm.subject,
          projectInternalId: projectInternalId,
          documentIds: checkedIds.join(','),
        },
        {
          headers: { Authorization: `Bearer ${getAdmin()}` },
        }
      );
      if (response.success) {
        clearForm();
        setAlert({
          type: 'success',
          message: 'Email sent successfully',
          open: true,
        });
      }
    } catch (error: any) {
      console.error(`GET ERROR:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
      setSendMailDialog(false);
      setCheckedIds([]);
      setInProgress(false);
    }
  };
  //dailoge Content for Mailable Send
  const dialogSendMailForDocument = () => {
    return (
      <Box className="mt-2">
        <Grid
          container
          spacing={2}
          style={{
            marginTop: '20px',
            width: '900px',
            border: '3px solid #efeeed',
            borderRadius: '10px',
            backgroundColor: '#f9f9f9',
            padding: '20px',
          }}
        >
          <Grid size={12} sx={{ mt: 2 }}>
            <TextField
              label="To"
              name="to"
              value={mailForm.to}
              sx={{ width: '100%', background: '#f9f9f9', paddingLeft: '2px' }}
              variant="standard"
              onChange={handleChangeMailBody}
            />
          </Grid>
          <Grid size={12} sx={{ mt: 2 }}>
            <TextField
              label="Subject"
              value={mailForm.subject}
              name="subject"
              sx={{ width: '100%', background: '#f9f9f9', paddingLeft: '2px' }}
              variant="standard"
              onChange={handleChangeMailBody}
            />
          </Grid>
          <Grid size={12}>
            <Box
              dangerouslySetInnerHTML={{ __html: mailcontentHTML() }}
              sx={{}}
            />
          </Grid>
          <Grid size={12}>
            <Box>
              <Typography component={'h6'} className="projectItemMainTitle">
                Attached Documents
              </Typography>

              {checkedIds.length > 0 && (
                <Grid container spacing={2}>
                  {rows
                    .filter((record: any) => checkedIds.includes(record.id))
                    .map((record: any) => {
                      return (
                        <Grid size={12}>
                          <Box
                            sx={{
                              backgroundColor: 'rgba(0, 244, 255, 0.08)',
                              color: '#000',
                              margin: '5px',
                              padding: '5px 12px',
                              width: '450px',
                              border: '1px solid #4ca7f6',
                              borderRadius: '4px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                            }}
                          >
                            <Box>
                              <p
                                style={{ fontWeight: 'bold', fontSize: '12px' }}
                              >
                                {record.document.fileName}
                              </p>
                              <p
                                style={{
                                  paddingBottom: '10px',
                                  fontSize: '12px',
                                  color: '#666',
                                }}
                              >
                                {record.notes}
                              </p>
                            </Box>
                            <Box>
                              <IconButton
                                aria-label="close"
                                onClick={() => {
                                  fetchSingleDocument(record.document.id);
                                }}
                              >
                                {fileDownloading === record.document.id ? (
                                  <CircularProgress size={24} />
                                ) : (
                                  <DownloadIcon />
                                )}
                              </IconButton>
                            </Box>
                          </Box>
                        </Grid>
                      );
                    })}
                  <Divider sx={{ mt: 2, mb: 2 }} />
                </Grid>
              )}
            </Box>
          </Grid>
        </Grid>
        <Box sx={{ mt: 2, textAlign: 'right' }}>
          <ButtonComponent
            keyName={'addBtn'}
            errors={[]}
            onClick={handleSendEmail}
            label={inProgress ? 'Sending...' : 'Send'}
          />
        </Box>
      </Box>
    );
  };

  const formFields: FormFieldData[] = [
    {
      name: 'name',
      label: 'Name',
      value: form.name.value,
      onChange: handleInputChange,
      isRequired: form.name.required,
      disabled: currentRecord ? true : false,
      size: 12,
      type: 'textfield',
      validationRules: [(value) => (!value ? 'Document name is required' : '')],
    },
    {
      name: 'documentTypeId',
      label: 'Document Type',
      value: form.documentTypeId.value,
      onChange: handleInputChange,
      isRequired: form.documentTypeId.required,
      isHidden: currentRecord ? true : false,
      size: 6,
      type: 'selectField',
      options: documentTypeList,
      validationRules: [
        (value) => (!value ? 'Document Type is required' : null),
      ],
    },
    {
      name: 'expiryDate',
      label: 'Expiry/Review Date',
      value: form.expiryDate.value,
      onChange: handleExpiryDate,
      isHidden: currentRecord ? true : false,
      isRequired: true,
      type: 'datepicker',
      size: 6,
      validationRules: [
        (value) => (!value ? 'Expiry/Review Date is required' : ''),
      ],
      keyname: 'expiryDate',
    },
    {
      name: 'notes',
      label: 'Notes',
      value: form.notes.value,
      minRows: 5,
      onChange: handleInputChange,
      isRequired: false,
      size: 12,
      type: 'textareaField',
    },
    {
      onChange: handleFileChange,
      value: form.documentFile.value,
      name: 'documentFile',
      isRequired: false,
      label: 'Document File',
      multiple: false,
      type: 'file',
      isHidden: currentRecord ? true : false,
      size: 12,
      existingFiles: [],
      onRemoveFile: handleRemove,
      onRemoveExistingFile: (file: any) => {
        //handleRemoveFileUpdate(file, 'resource_product');
      },
      onOpenFile: (id) => {
        // handleDownloadFile(id);
      },
    },
  ];
  const handleRowClick = (record: any) => {
    // console.log(record);
    setCurrentRecord(record);
    setForm({
      id: { required: false, value: record.id },
      notes: { required: true, value: record.notes },
      name: { required: true, value: record.name },
      documentTypeId: { required: true, value: record.documentTypeId },
      expiryDate: { required: true, value: record.expiryDate },
      documentFile: { required: true, value: [] },
    });
  };

  return (
    <div className="containergrid">
      <div className="mt-2">
        <Paper sx={{ width: '100%' }} className="mt-4">
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '10px',
              mb: 2,
            }}
          >
            <Typography variant="h6">Documents</Typography>
            <Box>
              <AddButtonComponent
                onClick={() => {
                  setCurrentId('Add');
                  setAddNewDialogOpen(true);
                }}
                keyName="checkIcon"
                label="Add new"
              />
              <Button
                style={{
                  textDecoration: 'none',
                  textTransform: 'capitalize',
                  color: 'rgba(0, 244, 255, 1)',
                  background: 'rgb(1, 1, 1)',
                  marginLeft: 3,
                }}
                variant="contained"
                disabled={isDownloading}
                startIcon={
                  <DownloadIcon sx={{ color: 'rgba(0, 244, 255, 1)' }} />
                }
                onClick={() => {
                  if (checkedIds.length > 0)
                    handleDownloadAll(checkedIds.join(','));
                  console.log(checkedIds);
                }}
              >
                {isDownloading ? 'Downloading...!' : 'Download'}
              </Button>
              <Button
                style={{
                  textDecoration: 'none',
                  textTransform: 'capitalize',
                  color: 'rgba(0, 244, 255, 1)',
                  background: 'rgb(1, 1, 1)',
                  marginLeft: 3,
                }}
                variant="contained"
                startIcon={
                  <MailOutlineOutlined sx={{ color: 'rgba(0, 244, 255, 1)' }} />
                }
                onClick={() => {
                  if (checkedIds.length > 0) {
                    setSendMailDialog(true);
                    const selectedDocumentTypes = rows
                      .filter((record: any) => checkedIds.includes(record.id)) // Filter records with matching IDs
                      .map((record: any) => record.documentTypeName);
                    const subjectData =
                      projectName +
                      ' ' +
                      selectedDocumentTypes +
                      ' requested documents';
                    setMailForm((prev: any) => {
                      return { ...prev, ['subject']: subjectData };
                    });
                  } else {
                    setAlert({
                      type: 'error',
                      message: 'Please select at least one document',
                      open: true,
                    });
                  }
                }}
              >
                {'Send'}
              </Button>
            </Box>
          </Box>
          <CustomPaginationActionsTable
            rows={rows}
            columns={columns}
            totalRecords={totalRecords}
            handlePagination={handlePagination}
            handleRowClick={(row) => {
              handleRowClick(row);
              setAddNewDialogOpen(true);
              //   navigate('/data-management/labour/' + row.id);
              //console.log(data);
            }}
            paginationModel={{
              page: paginate.offset,
              pageSize: paginate.limit,
            }}
            handleStatus={handleStatus}
          />
          <SimpleDialogComponent
            title={''}
            dialogContent={AddDialogContent()}
            open={addNewDialogOpen}
            handleClose={() => {
              setAddNewDialogOpen(false);
            }}
          />
          <SimpleDialogComponent
            title={''}
            dialogContent={dialogSendMailForDocument()}
            open={sendMailDialog}
            handleClose={() => {
              setSendMailDialog(false);
            }}
          />
          <AlertMessageComponent
            type={alert.type}
            open={alert.open}
            handleClose={handleCloseAlert}
            message={alert.message}
          />
        </Paper>
      </div>
    </div>
  );
};

export default React.memo(ProjectDocuments);
